module Client.Location


open Client
open Client.Services
open Shared
open global.Elmish
open System
open Thoth.Fetch
open Thoth.Json
open Fetch.Types
open Feliz
open Feliz.MaterialUI
open Fable.MaterialUI.Icons
open Fable.MaterialUI.MaterialDesignIcons
open Feliz.UseElmish
open Fable.Core.Experimental
open System.Text.RegularExpressions

let view = React.functionComponent (fun (inputProps: {| model : LoggedInModel; customerId : int; |}) ->
  let classes = Styles.useStyles ()
  let (location, setLocation) = React.useState(Option<ContactLocation>.None)
  let (error, setError) = React.useState<string option>(None)
  let (isLoading, setIsLoading) = React.useState(true)

  React.useEffectOnce(fun () ->
    promise {
      let! authHeader = Services.getAuthHeader()
      try
        let decoder = Services.decoder<Shared.ContactLocation option>
        let! response = Fetch.tryGet($"/api/Location/%i{inputProps.customerId}", headers = [ authHeader ], decoder = decoder)
        match response with
        | Ok v ->
          setLocation v
        | Result.Error fetchError ->
          match fetchError with
          | FetchError.DecodingFailed _ -> setError (Some "Problem parsing response")
          | FetchError.FetchFailed msg -> setError (Some "Problem fetching location")
          | FetchError.NetworkError _ -> setError (Some "Problem fetching location")
          | FetchError.PreparingRequestFailed _ -> setError (Some "Problem fetching location")
      with e ->
        setError (Some e.Message)
      setIsLoading false
    } |> ignore
  )

  let renderBreadcrumbs customerNameOption =
    let locationLabel = match customerNameOption with | None -> "Location" | Some name -> $"Location: %s{name}"
    Mui.breadcrumbs [
      breadcrumbs.children [
        Mui.link [
          prop.href (Client.Pages.toHash Pages.Page.Home)
          link.children "Home"
        ]
        Mui.link [
          prop.href (Client.Pages.toHash Pages.Page.Locations)
          link.children "Locations"
        ]
        Mui.typography [
          typography.color.textPrimary
          typography.children locationLabel
        ]
      ]
    ]

  let renderLocation loc =
    let customerId =
      match loc.CustomerId with
      | MasterCustomerId v -> v
      | CustomerId v -> v
    Mui.list [
      prop.width 100
      list.children [
        Mui.listItem [
          listItem.alignItems.flexStart
          listItem.button true
          listItem.component' "a"
          prop.href (Client.Pages.toHash (Pages.Page.LocationEquipments customerId))
          listItem.children [
            Mui.listItemText [
              listItemText.primary "Equipment"
              listItemText.secondary "View equipment and request supplies or service"
            ]
          ]
        ]
        Mui.listItem [
          listItem.alignItems.flexStart
          listItem.button true
          listItem.component' "a"
          prop.href (Client.Pages.toHash (Pages.Page.LocationInvoices customerId))
          listItem.children [
            Mui.listItemText [
              listItemText.primary "Invoices"
              listItemText.secondary "View outstanding invoices and make payments"
            ]
          ]
        ]
      ]
    ]
  Html.div [
    match location with
    | None ->
      renderBreadcrumbs None
    | Some loc ->
      renderBreadcrumbs (Some loc.CustomerName) // Breadcrumb with the location name

    if isLoading then
      Html.h2 "Location"
      Mui.circularProgress []
    else
      match error with
      | Some msg -> Html.p [ prop.style [ style.color.red ]; prop.text msg ]
      | None ->
        match location with
        | None ->
          Html.p "Location not found"
        | Some loc ->
          Html.h2 $"Location: %s{loc.CustomerName}"
          renderLocation loc
  ]
)